(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ndl-pdp-metaobject-variantgroup"] && !Shopify.designMode) return;
  try {
    (function () {
    const dropdowns = document.querySelectorAll('.pseudovariant-dropdown');

    dropdowns.forEach(function (dropdown) {
      const trigger = dropdown.querySelector('.pseudovariant-dropdown__trigger');
      const list = dropdown.querySelector('.pseudovariant-dropdown__list');
      const items = Array.from(dropdown.querySelectorAll('.pseudovariant-dropdown__item'));
      const allItems = dropdown.querySelectorAll('.pseudovariant-dropdown__item');

      if (!trigger || !list || items.length === 0) return;

      let activeIndex = -1;
      let isKeyboardNav = false;

      function getSelectedIndex() {
        return items.findIndex(function (item) {
          return item.classList.contains('pseudovariant-dropdown__item--selected');
        });
      }

      function setActiveDescendant(index) {
        items.forEach(function (item) {
          item.classList.remove('pseudovariant-dropdown__item--focused', 'keyboard-focus');
          item.removeAttribute('id');
        });

        if (index >= 0 && index < items.length) {
          const activeItem = items[index];
          const itemId = 'pseudovariant-option-' + index;
          activeItem.id = itemId;
          activeItem.classList.add('pseudovariant-dropdown__item--focused');
          if (isKeyboardNav) {
            activeItem.classList.add('keyboard-focus');
          }
          trigger.setAttribute('aria-activedescendant', itemId);
          activeItem.scrollIntoView({ block: 'nearest' });
        } else {
          trigger.removeAttribute('aria-activedescendant');
        }
      }

      function openDropdown() {
        trigger.setAttribute('aria-expanded', 'true');
        list.classList.add('is-open');
        activeIndex = getSelectedIndex();
        if (activeIndex === -1) activeIndex = 0;
        setActiveDescendant(activeIndex);
      }

      function closeDropdown() {
        trigger.setAttribute('aria-expanded', 'false');
        list.classList.remove('is-open');
        activeIndex = -1;
        isKeyboardNav = false;
        setActiveDescendant(-1);
      }

      function toggleDropdown() {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
          closeDropdown();
        } else {
          openDropdown();
        }
      }

      function selectItem(item) {
        const url = item.getAttribute('data-url');
        if (url) {
          window.location.href = url;
        }
      }

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        isKeyboardNav = false;
        toggleDropdown();
      });

      trigger.addEventListener('keydown', function (e) {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

        switch (e.key) {
          case 'Enter':
          case ' ':
            e.preventDefault();
            if (isExpanded && activeIndex >= 0) {
              selectItem(items[activeIndex]);
            } else {
              isKeyboardNav = true;
              toggleDropdown();
            }
            break;

          case 'ArrowDown':
            e.preventDefault();
            isKeyboardNav = true;
            if (!isExpanded) {
              openDropdown();
            } else {
              activeIndex = Math.min(activeIndex + 1, items.length - 1);
              setActiveDescendant(activeIndex);
            }
            break;

          case 'ArrowUp':
            e.preventDefault();
            isKeyboardNav = true;
            if (!isExpanded) {
              openDropdown();
            } else {
              activeIndex = Math.max(activeIndex - 1, 0);
              setActiveDescendant(activeIndex);
            }
            break;

          case 'Home':
            if (isExpanded) {
              e.preventDefault();
              isKeyboardNav = true;
              activeIndex = 0;
              setActiveDescendant(activeIndex);
            }
            break;

          case 'PageUp':
            if (isExpanded) {
              e.preventDefault();
              isKeyboardNav = true;
              activeIndex = 0;
              setActiveDescendant(activeIndex);
            }
            break;

          case 'End':
            if (isExpanded) {
              e.preventDefault();
              isKeyboardNav = true;
              activeIndex = items.length - 1;
              setActiveDescendant(activeIndex);
            }
            break;

          case 'PageDown':
            if (isExpanded) {
              e.preventDefault();
              isKeyboardNav = true;
              activeIndex = items.length - 1;
              setActiveDescendant(activeIndex);
            }
            break;

          case 'Escape':
            if (isExpanded) {
              e.preventDefault();
              closeDropdown();
              trigger.focus();
            }
            break;

          case 'Tab':
            if (isExpanded) {
              closeDropdown();
            }
            break;
        }
      });

      allItems.forEach(function (item) {
        item.addEventListener('click', function (e) {
          e.preventDefault();
          selectItem(item);
        });

        item.addEventListener('mouseenter', function () {
          isKeyboardNav = false;
          const index = items.indexOf(item);
          if (index >= 0) {
            activeIndex = index;
            setActiveDescendant(activeIndex);
          }
        });
      });

      document.addEventListener('click', function (e) {
        if (!dropdown.contains(e.target)) {
          closeDropdown();
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nh-paylater"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
      const wrappers = document.querySelectorAll('.pay-later__wrapper');
      for (const wrapper of wrappers) {
        wrapper.classList.add('pay-later__wrapper--loaded');
      }
    }, 5000);
  });
  } catch(e) { console.error(e); }
})();

})();
